import { aWhatsapp } from "../../shared/telefono";
import { comoDireccion } from "../../shared/domicilio";
import { useAvisarVacio } from "./BloqueFicha";

/* Dónde vive una persona.
 *
 * ── EL BLOQUE MÁS CERRADO DE LA FICHA, A PROPÓSITO ───────────────────────
 *
 * Igna, el 27/08/2026: *«hagamos al revés. Nadie puede verlo… se lo agrego yo
 * a mano a los que lo necesitan»*. `ver.domicilio_chofer` no cuelga de ningún
 * rol: se otorga de a una persona, y el día que se cargó no lo tenía nadie.
 * Por eso este bloque ni siquiera se dibuja sin el permiso — no un «no tenés
 * acceso», que ya cuenta que el dato existe y para quién.
 *
 * ── DE DÓNDE SALE, ESCRITO ───────────────────────────────────────────────
 *
 * De la planilla de RRHH, no de documentación. Importa porque el que
 * encuentra un domicilio viejo tiene que saber a quién pedirle que lo
 * corrija, y en Documentos no se toca.
 *
 * ── EL TELÉFONO DE ACÁ ES OTRO, Y SE DICE ────────────────────────────────
 *
 * El bloque «Teléfono» de arriba cruza el padrón con la planilla de Marcos.
 * Ésta es una tercera lista —236 de las 288 filas traen número— y no se
 * mezcla con aquéllas: se muestra acá, adentro del permiso, marcada. Fundirla
 * con las otras dos haría que el mismo teléfono apareciera o no según qué
 * permisos tenga el que mira, que es la clase de diferencia que hace dudar de
 * un dato que está bien.
 */
const Domicilio = ({ fila }) => {
  const direccion = comoDireccion(fila);
  const tel = String(fila?.telefono || "").trim();
  const link = aWhatsapp(tel);

  /* En la ficha, sin dirección el bloque no se dibuja (Igna, 02/10: lo vacío
   * no aparece). El texto de abajo queda para cualquier otro lugar que use
   * este componente sin pedir eso. */
  useAvisarVacio(!direccion);

  /* Con permiso y sin fila, el vacío YA NO ES AMBIGUO: la RLS filtra en
     silencio, pero quien llega hasta acá tiene la llave, así que lo que falta
     es la carga. Se dice cuál es —la planilla de RRHH— para que se pida donde
     se arregla. */
  if (!direccion) {
    return (
      <p className="tenue">Sin domicilio cargado.</p>
    );
  }

  return (
    <>
      <p className="pf-domicilio">{direccion}</p>

      {tel && (
        <p className="pf-chico">
          <span className="et">Teléfono de esa planilla</span>{" "}
          {link ? (
            <a href={link} target="_blank" rel="noreferrer">
              {tel}
            </a>
          ) : (
            <b>{tel}</b>
          )}
          {/* Un número que no se entiende no se dibuja como uno que falta: el
              que falta se pide, éste se corrige, y son dos trabajos. Varias
              filas traen dos números separados por barra, o el de un familiar
              aclarado al lado. */}
          {!link && (
            <span className="tenue"> · así como está no arma un enlace</span>
          )}
        </p>
      )}
    </>
  );
};

export default Domicilio;
